// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1paIi","validationTips":"StatementDescriptor_validationTips__1VfDb"};